var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn plan-and-approve-container" },
    [
      _c("EventStatusSelection"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-event-container margin-side" },
        [
          _c("TableHeader"),
          _vm._v(" "),
          _c(
            "div",
            {
              style: { "padding-top": _vm.fixElement ? "55px" : 0 },
              attrs: { id: "dt-body" }
            },
            [
              _vm._l(_vm.getListEvent, function(item, index) {
                return [
                  _c("EventRow", {
                    key: item,
                    staticClass: "event-row-wrapper",
                    attrs: { item: item, index: index }
                  })
                ]
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: { isLoading: _vm.getLoading, noDisplay: !_vm.getLoading } },
        [
          _c("Icon", {
            staticClass: "icon-size",
            attrs: { name: "spinner", scale: "5", pulse: "" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6581373e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6581373e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/PlanAndApprove.vue
// module id = 1778
// module chunks = 1